<template>
  <teleport to="body">
    <div class="collection-color__popup-root">
      <div class="collection-color__popup-bg" @click="closePopup"/>
      <div class="collection-color__popup">
        <h2 class="collection-color__title">{{ item?.value }}</h2>
        <div class="collection-color__image">
          <nuxt-img
            :src="String(item?.imageId)"
            fit="cover"
            width="600"
            height="600"
            :alt="item?.value || ''"
          />
        </div>
        <div
          @click="closePopup"
          class="collection-color__close-icon"
        >
          <img
            src="~/assets/img/svg/common/close.svg"
            alt=""
          />
        </div>
      </div>
    </div>
  </teleport>
</template>

<script setup lang="ts">
export type IColor = {
  id?: number,
  imageId?: number,
  slug?: string,
  sort?: number,
  value?: string,
}
const props = defineProps<{
  item: IColor | null;
}>();
const emits = defineEmits([
  'close'
])
const closePopup = () => {
  emits('close')
}
</script>

<style scoped lang="scss">
.collection-color__popup-root {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column;
  z-index: 997;
  align-items: center;
  padding: 20px;
  border-radius: 30px;
}
.collection-color__popup-bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  transition: 0.5s all;
}
.collection-color__popup {
  position: relative;
  background: var(--text-white);
  border-radius: 30px;
  padding: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 1;
}
.collection-color__title {
  margin-bottom: 16px;
}
.collection-color__image {
  max-width: 450px;
  max-height: 450px;
  border-radius: 30px;
  overflow: hidden;
  border: 1px solid #989898;
}
.collection-color__close-icon {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 37px;
  height: 37px;
  border-radius: 10px;
  background: #F4F3F1;
  cursor: pointer;

  & > img {
    transition: transform 0.2s ease;
  }

  &:hover {
    & > img {
      transform: rotate(180deg);
    }
  }
}
@media screen and (max-width: 1400px) {
  .collection-color__popup {
    width: fit-content;
  }
  .collection-color__close-icon {
    position: absolute;
    top: 15px;
    right: 15px;
  }
}
@media screen and (max-width: 991px) {
  .collection-color__popup {
    width: fit-content;
    border-radius: 20px;
  }
  .collection-color__close-icon {
    top: 10px;
    right: 10px;
    width: 27px;
    height: 27px;
    border-radius: 10px;
  }
}
@media screen and (max-width: 640px) {
  .collection-color__popup-root {
  }
  .collection-color__popup {
  }
  .collection-color__title {
    font-size: 28px;
  }
}
</style>
